module.exports = __webpack_public_path__ + "img/SKMA_emergency2.72bcf16b.jpg";